import * as React from 'react';
import './ApplicationCard.css';
import { APPLICATION_CARD_TEXT } from './lang';
import { ApplicationCardInfo } from './ApplicationCardInfo';
import type { ApplicationPageData } from '../../graphql/ApplicationCardList/types';
import {
  STUDY_MODE_DISPLAY_MAP,
  PROGRAMME_DISPLAY_MAP,
} from '../ApplicationForm';
import { convertEntryYearMap } from '../const';
import { APPLICATION_STATUS_TYPE } from '../../../../utils/statusConstants/statusConstants';

export type ApplicationCardProps = {
  deptLabel: string;
  cardData: ApplicationPageData;
};

export const ApplicationCard: React.FunctionComponent<ApplicationCardProps> = (
  props: ApplicationCardProps,
) => {
  const { cardData, deptLabel } = props;
  const {
    id: applicationId,
    status,
    applicationNo,
    needsDeclaration,
  } = cardData;

  return (
    <div>
      {cardData.programme !== null && (
        <div className="card flex flex-col w-[24rem] h-[15rem] justify-center ml-auto mr-8 mb-8 shadow-lg shadow-black/40">
          <div
            className="text-center text-white w-full h-full py-4 flex flex-col justify-between"
            style={{
              backgroundColor:
                cardData.status === APPLICATION_STATUS_TYPE.WITHDRAWN
                  ? 'rgba(140, 30, 30,0.5)'
                  : 'rgb(160, 45, 40)',
            }}
          >
            <div>
              <h1 className="font-bold text-lg">{deptLabel}</h1>
              <h3 title="Application No.">{applicationNo}</h3>
            </div>

            <div>
              <h2>
                {STUDY_MODE_DISPLAY_MAP?.[cardData.studyMode] + ' '}
                {PROGRAMME_DISPLAY_MAP?.[cardData.programme]}
              </h2>

              <h3>
                {convertEntryYearMap[cardData.entryYear] + ' '}
                {APPLICATION_CARD_TEXT.ENTRY}
              </h3>
            </div>
          </div>

          <ApplicationCardInfo
            applicationId={applicationId}
            status={status}
            needsDeclaration={needsDeclaration}
          />
        </div>
      )}
    </div>
  );
};
